export default "__VITE_ASSET__BTcJ8CHM__"